import { useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { Logo } from "@/components/site/Logo";

export default function GestaoLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/gestao/inicio" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Bem-vinda de volta.");
    } catch (err) {
      setError(errorMessage(err, "Não foi possível iniciar sessão."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-eden-bg px-5" data-testid="gestao-login-page">
      <div className="w-full max-w-sm">
        <Logo />
        <h1 className="mt-8 font-display text-2xl font-bold text-eden-text">Painel de gestão</h1>
        <p className="mt-1 text-sm text-eden-muted">Acesso reservado à staff do EDEN RP.</p>
        <form onSubmit={submit} className="mt-8 space-y-5" noValidate>
          <div className="space-y-1.5">
            <label htmlFor="login-email" className="block text-sm font-medium text-eden-text">Email</label>
            <input id="login-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-eden" data-testid="login-email-input" />
          </div>
          <div className="space-y-1.5">
            <label htmlFor="login-password" className="block text-sm font-medium text-eden-text">Palavra-passe</label>
            <input id="login-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-eden" data-testid="login-password-input" />
          </div>
          {error && <p role="alert" className="rounded-sm border border-red-900/60 bg-red-950/40 px-3 py-2 text-sm text-red-300" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit-button">{busy ? "A entrar…" : "Entrar"}</button>
        </form>
        <a href="/" className="mt-8 inline-block text-sm text-eden-muted hover:text-eden-text" data-testid="login-back-link">← Voltar ao site</a>
      </div>
    </main>
  );
}
